module.exports = __webpack_public_path__ + "static/media/DT-top-mobile.589d0c52.png";